<template>
  <div>
    <div class="Image" @click="showVideo">
      <img class="avatar-url" :src="imgUrl"  />
    </div>
    <a-modal :visible="visible"
             destroyOnClose
             :title="title"
             @cancel="visible = false"
             :onText="'关闭'"
             :width="500"
             :height="500"
             :maskClosable="false">
      <video-player class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="playerOptions">
      </video-player>
      <template slot="footer">

        <a-button key="submit" type="primary"  @click="visible = false">
          关闭
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import mImage from "@/components/business/mImage/mImage";
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";

export default {
  name: "mVideo",
  props: {
    imgUrl: { type: String },
    videoUrl: { type: String },
    title: { type: String },
  },
  data () {
    return {
      playerOptions: {
        // preload: 'auto',
        height: '400',
        // autoplay: true,
        // muted: true,
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        loop: false,
        sources: [{
          type: "video/mp4", // 类型
          src: '' // url地址
        }],
        poster: '',
        language: 'zh-CN',
        // controlBar: {
        //   timeDivider: true, // 当前时间和持续时间的分隔符
        //   durationDisplay: true, // 显示持续时间
        //   remainingTimeDisplay: true, // 是否显示剩余时间功能
        //   fullscreenToggle: true // 是否显示全屏按钮
        // }
      },
      visible: false
    }
  },
  methods: {
    showVideo() {
      this.playerOptions.sources[0].src = this.videoUrl;
      this.visible = !!this.videoUrl;

    }
  },
  computed: {

    init() {
      const {videoUrl} = this;
      if (videoUrl) {
        this.playerOptions.sources = [{ type: "video/mp4", src: videoUrl }];
        this.playerOptions.poster = videoUrl;
      }
      return this.videoUrl
    }

  },
  components: {
    mImage,
    videoPlayer
  }
};
</script>
<style>
.video-js {
  width: 100%;
  /*height: 400px;*/
}
</style>
<style scoped lang="less">
.Image {
  width: 100%;
  height: 40px;
  display: flex;
  overflow: hidden;
  max-width: 195px;
  justify-content: center;

  img {
    width: 60px;
    height: 40px;
    margin-right: 5px;
  }

  .item {
    margin-right: 5px;
  }
}
</style>
